enum OnboardingStatus {
  pass = 'pass',
  fail = 'fail',
  pending = 'pending',
  incomplete = 'incomplete',
  none = 'none',
}

export default OnboardingStatus;
